module.exports = __webpack_public_path__ + "img/fa2b7df67c3394ff41df7a2ab04f1e4b.png";